import { _ as r } from "../internals/export.js";
import { f as n } from "../internals/function-uncurry-this.js";
import { t } from "../internals/to-string.js";
var i = String.fromCharCode,
  e = n("".charAt),
  a = n(/./.exec),
  o = n("".slice),
  s = /^[\da-f]{2}$/i,
  f = /^[\da-f]{4}$/i;
r({
  global: !0
}, {
  unescape: function unescape(r) {
    for (var n, c, u = t(r), l = "", m = u.length, p = 0; p < m;) {
      if ("%" === (n = e(u, p++))) {
        if ("u" === e(u, p)) {
          if (a(f, c = o(u, p + 1, p + 5))) {
            l += i(parseInt(c, 16)), p += 5;
            continue;
          }
        } else if (a(s, c = o(u, p, p + 2))) {
          l += i(parseInt(c, 16)), p += 2;
          continue;
        }
      }
      l += n;
    }
    return l;
  }
});